export default function Loading() {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-black">
      <div className="spinner-border text-danger" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
